@if ((facade.multiSavingsPlans$ | async)?.length) {
  <div class="row thead">
    <div class="col-2">{{ 'savings-plan.add-savings-plan.amount' | transloco }}</div>
    <div class="col">{{ 'savings-plan.add-savings-plan.name' | transloco }}</div>
  </div>
  <hr />
  @for (savingsPlan of facade.multiSavingsPlans$ | async; track savingsPlan.isin) {
    <div class="row mb-3 align-items-center">
      <div class="col-2">
        <div class="input-group-material keepcolor" data-zid="savingsplan-amount" [class.input-group-material--error]="savingsPlan.error">
          <input
            type="text"
            autocomplete="off"
            inputmode="decimal"
            class="form-control"
            [value]="savingsPlan.amount | ignoreThousandSeparator"
            (keyup)="handleChangeAmount(savingsPlan, $event)"
          />
          <div class="input-group-append">
            <span class="input-group-text">€</span>
          </div>
        </div>
      </div>
      <div data-zid="isin-strategie" class="col-8">
        {{ savingsPlan.asset?.longName }} <span class="zero-text p-small-reg label">- {{ savingsPlan.asset?.isin }}</span>
        @if (savingsPlan.error) {
          <div class="text-color-error text-size-small">{{ savingsPlan.error | transloco }}</div>
        }
      </div>
      <div class="col-2 text-right">
        <svg class="icon icon-18 cursor-pointer" (click)="facade.removeSavingsPlanFromForm(savingsPlan)">
          <use xlink:href="/assets/img/svgs/svgset.svg#cross-black" />
        </svg>
      </div>
    </div>
    <hr />
  }
  <div class="row mb-3">
    <div class="col">
      <div class="link-secondary cursor-pointer no-select text-decoration-none" (click)="openFurtherSavingsPlanModal()">
        <svg class="icon icon-18">
          <use xlink:href="/assets/img/svgs/svgset.svg#add-instrument" />
        </svg>
        {{ 'savings-plan.add-savings-plan.add' | transloco }}
      </div>
    </div>
  </div>
  <hr />
} @else {
  <div class="row mb-4">
    <div class="col">
      <web-components-asset-search
        data-zid="savingsplan-search-input"
        type="savings-plan-create-form"
        (assetSelected)="facade.addAssetToForm($event)"
      />
    </div>
  </div>
}
